// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Outlook = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Outlook = void 0;
  _react = _interopRequireWildcard(_react);
  var React = _react;
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Outlook = _exports.Outlook = function Outlook(props) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/React.createElement("path", {
      fill: "#0A2767",
      d: "M20 9.975a.46.46 0 0 0-.214-.392h-.002l-.009-.005-6.93-4.19a.913.913 0 0 0-1.039 0l-6.93 4.19-.009.005a.467.467 0 0 0 .011.79l6.93 4.19q.046.03.093.056a.91.91 0 0 0 .947-.056l6.93-4.19a.46.46 0 0 0 .221-.398"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#0364B8",
      d: "M5.686 7.178h4.547v4.257H5.686zM19.07 2.85V.902A.875.875 0 0 0 18.227 0H6.426a.875.875 0 0 0-.844.902V2.85l6.977 1.9z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#0078D4",
      d: "M5.582 2.85h4.651v4.275H5.582z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#28A8EA",
      d: "M14.884 2.85h-4.652v4.275l4.652 4.275h4.186V7.125z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#0078D4",
      d: "M10.232 7.125h4.652V11.4h-4.652z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#0364B8",
      d: "M10.232 11.4h4.652v4.275h-4.652z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#14447D",
      d: "M5.684 11.436h4.548v3.87H5.684z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#0078D4",
      d: "M14.883 11.4h4.186v4.275h-4.186z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "url(#prefix__b)",
      d: "m19.788 10.347-.009.004-6.93 3.98q-.044.03-.093.054a1 1 0 0 1-.376.095l-.378-.226a1 1 0 0 1-.093-.055l-7.024-4.093h-.003l-.23-.131v8.057c.004.538.433.971.96.968h13.445q.01-.002.023-.004.167-.011.325-.07a1 1 0 0 0 .131-.069c.031-.018.085-.057.085-.057a.97.97 0 0 0 .38-.768V9.975a.43.43 0 0 1-.213.372"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#0A2767",
      d: "M19.63 9.943v.494l-7.247 5.095-7.502-5.423a.01.01 0 0 0-.005-.005l-.689-.423v-.356l.284-.005.6.352.014.005.051.033s7.052 4.109 7.07 4.118l.27.162q.033-.015.074-.029c.014-.01 7-4.023 7-4.023z",
      opacity: 0.5
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#1490DF",
      d: "m19.788 10.347-.009.005-6.93 3.98q-.044.03-.093.053a.95.95 0 0 1-.946-.053l-6.93-3.98-.009-.005a.43.43 0 0 1-.219-.372v8.057c.004.538.433.971.96.968h13.43a.963.963 0 0 0 .96-.968V9.975a.43.43 0 0 1-.214.372"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#212B36",
      d: "m12.949 14.273-.104.06a.946.946 0 0 1-.459.152l2.637 3.185 4.6 1.132a.97.97 0 0 0 .292-.372z",
      opacity: 0.1
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#212B36",
      d: "m13.419 14.004-.574.33q-.044.029-.093.053a.95.95 0 0 1-.365.098l1.235 3.479 6.002.836a.97.97 0 0 0 .376-.767v-.104z",
      opacity: 0.05
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#28A8EA",
      d: "M5.624 19h13.417a.95.95 0 0 0 .574-.19l-7.614-4.555a1 1 0 0 1-.093-.055l-7.023-4.093h-.003l-.23-.132v8.03c0 .549.435.994.972.995"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#212B36",
      d: "M11.164 4.671v10.132a.873.873 0 0 1-.851.874h-5.66V4.276h.93V3.8h4.73c.47.002.85.39.851.87",
      opacity: 0.1
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#212B36",
      d: "M10.699 5.146v10.132a.8.8 0 0 1-.07.332.85.85 0 0 1-.781.54H4.652V4.275h5.196a.77.77 0 0 1 .386.1.87.87 0 0 1 .465.771",
      opacity: 0.2
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#212B36",
      d: "M10.699 5.146v9.182a.87.87 0 0 1-.851.872H4.652V4.275h5.196a.77.77 0 0 1 .386.1.87.87 0 0 1 .465.771",
      opacity: 0.2
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#212B36",
      d: "M10.234 5.146v9.182c0 .48-.381.87-.851.872h-4.73V4.275h4.73c.47 0 .851.39.85.87z",
      opacity: 0.2
    }), /*#__PURE__*/React.createElement("path", {
      fill: "url(#prefix__c)",
      d: "M.853 4.275H9.38c.47 0 .852.39.852.871v8.709c0 .48-.381.87-.852.87H.853a.86.86 0 0 1-.853-.87V5.146c0-.48.382-.87.853-.87"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#fff",
      d: "M2.663 7.928c.21-.457.55-.84.974-1.099a2.9 2.9 0 0 1 1.548-.396c.502-.011.997.119 1.432.376.408.248.738.613.947 1.05.229.48.342 1.009.332 1.543a3.64 3.64 0 0 1-.342 1.615 2.55 2.55 0 0 1-.976 1.086 2.8 2.8 0 0 1-1.486.386 2.75 2.75 0 0 1-1.464-.38 2.53 2.53 0 0 1-.96-1.052 3.4 3.4 0 0 1-.335-1.525 3.74 3.74 0 0 1 .33-1.604m1.038 2.579c.112.289.302.54.548.723.25.179.55.27.856.263.325.013.646-.082.914-.272.242-.182.427-.434.532-.723a2.9 2.9 0 0 0 .17-1.008 3.1 3.1 0 0 0-.16-1.021 1.6 1.6 0 0 0-.516-.754c-.26-.198-.58-.299-.905-.285a1.46 1.46 0 0 0-.876.266c-.25.184-.444.437-.558.729a2.96 2.96 0 0 0-.004 2.083z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#50D9FF",
      d: "M14.883 2.85h4.186v4.275h-4.186z"
    })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
      id: "prefix__b",
      x1: 12.327,
      x2: 12.327,
      y1: 9.975,
      y2: 19,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#35B8F1"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#28A8EA"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "prefix__c",
      x1: 1.778,
      x2: 8.668,
      y1: 3.595,
      y2: 15.28,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#1784D9"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 0.5,
      stopColor: "#107AD5"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#0A63C9"
    })), /*#__PURE__*/React.createElement("clipPath", {
      id: "prefix__a"
    }, /*#__PURE__*/React.createElement("path", {
      fill: "#fff",
      d: "M0 0h20v20H0z"
    }))));
  };
});
